import React from "react";
import { useHistory } from "react-router-dom";

function RegisterSuccess() {
  const history = useHistory();

  return (
    <>
      <div className="register-success font-bold">
        <div className="success-form">
          <h3>가입 신청이 완료되었습니다.</h3>
          <p className="txt-center font-medium mb-5">
            관리자의 승인을 기다려주세요.
          </p>
          <section className="txt-center txt-dark-gray mt-5">
            <p className="mt-5">
              <button
                className="btn-blue-md mb-2 font-bold width-20 mt-5"
                onClick={() => history.push("/")}
              >
                홈으로
              </button>
              <p className="txt-gray mt-2 font-small">고객센터 070-7114-0418</p>
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default RegisterSuccess;
